<template>
  <v-card :key="affiliate.affiliateId" class="user-profile-card">
    <v-card-title>
      <span v-if="!!affiliate.clubSite">
        <a :href="affiliate.clubSite" target="_blank"><font-awesome-icon icon="globe" /></a>
        &nbsp;<a :href="affiliate.clubSite" target="_blank">{{ affiliate.name }}</a>
      </span>
      <span v-else>
        {{ affiliate.name }}
      </span>
      &nbsp;| {{ affiliate.region }}&nbsp;       
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col>
          <h3>Affiliate Representative:</h3>
          <p>
            {{ affiliate.contact.name }}
          </p>  
          <p class="mb-2">
            <span v-if="!!affiliate.contact.phoneNumber"><a :href="`tel:${affiliate.contact.phoneNumber}`">
              <font-awesome-icon icon="phone" />
            </a>&nbsp;{{affiliate.contact.phoneNumber}}</span>
            <br />
            <span v-if="!!affiliate.contact.email"><a :href="`mailto:${affiliate.contact.email}`">
              <font-awesome-icon icon="envelope" />
            </a>&nbsp;{{affiliate.contact.email}}</span>
          </p>
        </v-col>
      <v-divider vertical light class="d-none d-sm-flex"></v-divider>
        <v-col>
          <h3>President:</h3>
          <p>
            {{ affiliate.president.name }}
          </p>  
          <p class="mt-3 mb-2">
            <span v-if="!!affiliate.president.phoneNumber"><a :href="`tel:${affiliate.president.phoneNumber}`">
              <font-awesome-icon icon="phone" />
            </a>&nbsp;{{affiliate.president.phoneNumber}}</span>
            <br />
            <span v-if="!!affiliate.president.email"><a :href="`mailto:${affiliate.president.email}`">
              <font-awesome-icon icon="envelope" />
            </a>&nbsp;{{affiliate.president.email}}</span>
          </p>            
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import Vue from "vue";
export default Vue.extend({
  name: "AffiliateCard",
  props: {
    affiliate: Object,
  },
});
</script>